import React, { Component } from 'react';
import { Row, Form, FormGroup, Button, Input, Col, ListGroup } from 'reactstrap';
import { FilterFormCheckbox } from './filterformcheckbox';
import { setCheckboxValue, searchCheckboxValue } from './helper';
import { MASTER_SECTION_TYPE, MASTER_TYPE, DEFAULT_CHECKBOX_VALUES, ENTER } from '../constants';
class MasterDataFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false,
            checkboxData: DEFAULT_CHECKBOX_VALUES
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.appliedFilterValues !== prevProps.appliedFilterValues) {
            this.setState({
                checkboxData: this.props.appliedFilterValues
            })
        }
    }
    toggle = () => {
        this.setState((prevState) => ({
            popoverOpen: !prevState.popoverOpen
        }))
    }
    handleCheckbox = (event) => {
        const tempCheckbox = setCheckboxValue(this.state.checkboxData, event)
        this.setState({
            checkboxData: tempCheckbox
        })
    }
    handleReset = () => {
        this.setState({
            checkboxData: DEFAULT_CHECKBOX_VALUES
        })
    }
    handleApplyFilters = () => {
        this.props.masterDataFiltercallback(this.state.checkboxData);
        this.toggle();
    }
    handleSearchChange = (event) => {
        if (event.key === ENTER) {
            event.preventDefault();
            this.props.searchCallback(event.target.value)
        }
    }
    render() {
        return (
            <Row className="d-flex justify-content-between no-gutters mb-3 position-relative">
                <Col sm='22'>
                    <Form className="form-search mb-3 mb-sm-0">
                        <FormGroup className="mb-0 input-search">
                            <i className="icon-search position-absolute search-icon-color" ></i>
                            <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search within master data keys" autoComplete="off" />
                        </FormGroup>
                    </Form>
                </Col>
                <div className="filter-wrapper ml-auto">
                    <div>
                        <Button color='primary' id="Popover1" className={this.state.popoverOpen ? 'btn-filter btn-icon' : 'btn-filter btn-icon'} outline size="sm" onClick={this.toggle}>
                            <i className="icon-filter"></i>
                        </Button>
                    </div>
                </div>
                <div className={this.state.popoverOpen ? "position-absolute filter-popover d-block bg-light p-4 master-filter" : "position-absolute filter-popover d-none p-3"}>
                    <Form>
                        <Row noGutters className="mb-4">
                            <Col className="filter-category p-3 py-sm-0">
                                <span className="filter-popover-header-item d-flex justify-content-between">Key Type<i className="icon-minus d-sm-none"></i></span>
                                <ListGroup className="filter-options">
                                    {MASTER_SECTION_TYPE.map(keyTypeCheckboxData => {
                                        const tempValue = searchCheckboxValue(this.state.checkboxData, keyTypeCheckboxData)
                                        return (
                                            <FilterFormCheckbox checkboxCheckedValue={tempValue} checkboxCallback={this.handleCheckbox} key={keyTypeCheckboxData} checkboxData={keyTypeCheckboxData} />
                                        )
                                    })}
                                </ListGroup>
                            </Col>
                            <Col className="filter-category p-3 py-sm-0">
                                <span className="filter-popover-header-item d-flex justify-content-between">Data Type<i className="icon-plus d-sm-none"></i></span>
                                <ListGroup className="filter-options">
                                    {MASTER_TYPE.map(dataTypeCheckboxData => {
                                        const tempValue = searchCheckboxValue(this.state.checkboxData, dataTypeCheckboxData)
                                        return (
                                            <FilterFormCheckbox checkboxCheckedValue={tempValue} checkboxCallback={this.handleCheckbox} key={dataTypeCheckboxData} checkboxData={dataTypeCheckboxData} />
                                        )
                                    })}
                                </ListGroup>
                            </Col>
                        </Row>
                        <Row className='filter-buttons'>
                            <Button color='primary' className='filter-reset-button' onClick={this.handleReset}>Reset</Button>
                            <Button color='primary' className='filter-apply-button' onClick={this.handleApplyFilters}>Apply</Button>
                        </Row>
                    </Form >
                </div>
            </Row>
        )
    }
}

export default MasterDataFilter